module.exports = __webpack_public_path__ + "img/ico_light_4.c1495054.png";